export const formatPrice = (price: string, currencySymbol: string, minorUnit: number): string => {
  const formattedPrice = Number(price) / 10 ** minorUnit
  return `${formattedPrice.toFixed(2)} ${currencySymbol}`
}
